import { useSafe } from "@/safe/SafeContextValue";
import type {
  RuntimePostureDowngradeCue,
  RuntimePostureSnapshot,
  RuntimeState,
  RuntimeWritePathState
} from "@/safe/runtimePolicy";

export function useRuntimeState(): RuntimeState {
  const safe = useSafe();
  return safe.runtime;
}

export function useRuntimePosture(): RuntimePostureSnapshot {
  return useRuntimeState().posture;
}

export function useRuntimeWritePath(): RuntimeWritePathState {
  return useRuntimeState().writePath;
}

export function useRuntimeDowngradeCues(): RuntimePostureDowngradeCue[] {
  return useRuntimePosture().downgrade?.cues ?? [];
}
